const ownerId = 280242;

const createAdaptive = config => {
    return new Promise((resolve) => {
        if (!window.Ya || !window.Ya.adfoxCode) {
            return;
        }

        window.Ya.adfoxCode.createAdaptive({
            ownerId: config.ownerId || ownerId,
            containerId: config.containerId,
            params: config.params,
            onRender: config.onRender
        }, config.media, {
            tabletWidth: 830,
            phoneWidth: 480,
            isAutoReloads: config.isAutoReloads || false
        });

        resolve();
    })
}

export { createAdaptive };
